import {createEndpoint} from './createEndpoint';

export const endpoints = {
  auth: {
    revokeMBIDRefreshToken: createEndpoint(
      '/api/auth_service/token/revoke/:jti',
    ),
    revokeOAuthRefreshToken: createEndpoint<
      string,
      {token: string; tokenTypeHint: 'access_token' | 'refresh_token'}
    >('/api/oauth2/token/revoke'),
  },
  banner: {
    getBanner: createEndpoint<string, {country: string; platform: string}>(
      `/api/customer_frontend_service/public/banner`,
    ),
  },
  feedback: {
    postFeedback: createEndpoint(
      `/api/customer_frontend_service/public/feedback`,
    ),
  },
  news: {
    getNews: createEndpoint<
      string,
      {country: string; platform: string; appVersion?: string}
    >(`/api/customer_frontend_service/public/announcement/pages`),
  },
  bankId: {
    getStatus: createEndpoint(
      `/api/customer_frontend_service/customer/mbid/sign/:id/status`,
    ),
  },
  bills: {
    getBills: createEndpoint(
      `/api/bill_service/:countryCode/:customerId/bills`,
    ),
  },
};
